@if (billingElement) {
  <app-tabs>
    <app-tab [title]="'settlement.view.details'">
      <app-value-details
        [collection]="billingMasterdata"
        [data]="billingElement"
      ></app-value-details>
    </app-tab>
    <app-tab [title]="'settlement.view.data'">
      <app-table
        [config]="tableConfig"
        [data]="tableData">
      </app-table>
    </app-tab>
    <app-tab [title]="'settlement.view.request'">
      {{ billingElement.rsmTextRequest ?? '-' }}
    </app-tab>
    <app-tab [title]="'settlement.view.answer'">
      {{ billingElement.rsmTextResponse ?? '-' }}
    </app-tab>
  </app-tabs>
}

